import { render, staticRenderFns } from "./GanttChart.vue?vue&type=template&id=d8522846&"
import script from "./GanttChart.vue?vue&type=script&lang=js&"
export * from "./GanttChart.vue?vue&type=script&lang=js&"
import style0 from "./GanttChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports